/**
* 分页组件
*/ 
<template>
  <el-pagination class="page-box" 
  @size-change="handleSizeChange" 
  @current-change="handleCurrentChange" background :current-page="params.currentPage" :page-sizes="[5, 10, 25, 50]" :page-size="params.pageSize" 
  layout="total, sizes, prev, pager, next, jumper" :total="params.total">
  </el-pagination>
</template>

<script>
export default {
  name: 'Pagination',
  props: ['params'],
  data() {
    return {
      pageParams: {
        currentPage: this.params.currentPage,
        pageSize: this.params.pageSize
      }
    }
  },
  created() {
  },

  methods: {
    handleSizeChange(val) {
      this.pageParams.pageSize = val
      this.$parent.pageList(this.pageParams.currentPage,this.pageParams.pageSize)
    },
    handleCurrentChange(val) {
      this.pageParams.currentPage = val
      this.$parent.pageList(this.pageParams.currentPage,this.pageParams.pageSize)
    }
  }
}
</script>

<style>
.page-box {
  margin: 10px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue